import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Vaga } from '../../services/vaga.model'
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  bLoading: boolean = true;
  vagas: Observable<any[]>;
  vaga: Observable<Vaga>;

  constructor(
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private dataService: DataService,
    public auth: AuthService,
    private router: Router
    ) {
      // Coleta as vagas e trás também o ID associado
      this.vagas = afs.collection('vagas').valueChanges({idField: 'uid'});
  }

  ngOnInit() {
    this.vagas.subscribe(() => this.bLoading = false);
  }

  IrInscricao() {

    // Verifica se está logado
    this.afAuth.auth.onAuthStateChanged(user => {

      if (user){
        
        // Redireciona
        this.router.navigate(['/processing']);

      }else{

        // Redireciona
        this.router.navigate(['/login']);
      }
    });
  }

  Selecionar(vaga: Vaga) {

    // Verifica se está logado
    this.afAuth.auth.onAuthStateChanged(user => {

      if (user){
        // Guardo a vaga na memória
        this.dataService.Set_Vaga(vaga);

        // Redireciona
        this.router.navigate(['/processing']);

      }else{

        // Redireciona
        this.router.navigate(['/login']);
      }
    });
  }
}